import React from 'react'
import { ClaimResponseType } from '../../redux/actions/types'
import { OtherClaimCard } from '../OtherClaimCard/OtherClaimCard'
import Loader from '../UI/Loader/Loader'
import styles from './OtherClaimsSection.module.css'

interface OtherClaimsSectionProps {
  otherClaims: ClaimResponseType[]
  isLoading: boolean
}

export const OtherClaimsSection: React.FC<OtherClaimsSectionProps> = ({
  otherClaims,
  isLoading,
}) => {
  if (isLoading) {
    return (
      <div className={styles.otherClaimsSection}>
        <h2 className={styles.otherClaimsTitle}>Другие заявки</h2>
        <Loader />
      </div>
    )
  }

  return (
    <div className={styles.otherClaimsSection}>
      <h2 className={styles.otherClaimsTitle}>Другие заявки</h2>
      {otherClaims.length > 0 ? (
        <div className={styles.otherClaimsList}>
          {otherClaims.map((claim: ClaimResponseType) => (
            <OtherClaimCard key={claim.id} claim={claim} />
          ))}
        </div>
      ) : (
        <div className={styles.noOtherClaims}>
          <p>Нет других заявок на этот период</p>
        </div>
      )}
    </div>
  )
}
